import React, { PureComponent } from 'react';
import {connect} from 'react-redux';

import {addNotification,dismissNotification} from 'actions/notifications';

export default function(ComposedComponent){
    class withNotifications extends PureComponent{
        render(){
            return <ComposedComponent {...this.props} dismissNotification={this.props.dismissNotification} addNotification={this.props.addNotification}/>
        }
    }
    return connect(null,{addNotification,dismissNotification})(withNotifications);
}


// WEBPACK FOOTER //
// ./src/containers/WithNotifications.js